const initialState = {
  productDetail: {},
  productDocDetail: [],
  productCoverImg: [],
  productThumbnailImg: [],
  productTermsConditionsDoc: [],
  productVideos: [],
  multimediaImages: [],
  productVideosLinks: [],
  updateRevRatRes: [],
  deleteRevRes: [],
  endpointRes: {},
  grantTypeReqAttr: [],
  tokenResponse: {},
  tokenErrorResponse: {},
  applicationOfUsers: [],
  mssApiAccessToken: '',
  baseUrl: '',
  billingCycleMasterData: undefined,
  sendMail: undefined,
  emailStatus: '',
  replyCommentText: {},
  downloadedFile: [],
  productDocList: [],
  totalProductQty: -1,
  selectedProductQty: 1,
  productDisplayNames: [],
  highlightsDocument: [],
  userTermsConsent: ''
};

const ProductDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PRODUCT_BY_ID':
      return Object.assign({}, state, {
        productDetail: action.payload,
        endpointRes: ''
      });
    case 'GET_PRODUCT_DOCS_BY_ID':
      return Object.assign({}, state, { productDocDetail: action.payload });
    case 'GET_PRODUCT_COVER_IMG':
      return Object.assign({}, state, { productCoverImg: action.payload });
    case 'GET_PRODUCT_THUMBNAIL_IMG':
      return Object.assign({}, state, { productThumbnailImg: action.payload });
    case 'GET_TERMS_CONDITIONS_DOCUMENT':
      return Object.assign({}, state, {
        productTermsConditionsDoc: action.payload
      });
    case 'GET_PRODUCT_VIDEOS_BY_ID':
      return Object.assign({}, state, { productVideos: action.payload });
    case 'GET_PRODUCT_MULTIMEDIA_IMG_BY_ID':
      return Object.assign({}, state, { multimediaImages: action.payload });
    case 'GET_PRODUCT_VIDEOS_LINK_BY_ID':
      return Object.assign({}, state, { productVideosLinks: action.payload });
    case 'GET_DOWNLOAD_SAMPLE_DATA':
      return Object.assign({}, state, { downloadedFile: action.payload });
    case 'CLEAR_PRODUCT_DOC_LIST':
      return Object.assign({}, state, { productDocList: action.payload });
    case 'GET_DOWNLOAD_PRODUCT_DOC_LIST':
      return {
        ...state,
        productDocList: state.productDocList.concat(action.payload)
      };
    case 'RESET_PRODUCT_DOCS':
      return Object.assign({}, state, {
        productDocDetail: [],
        productCoverImg: [],
        productThumbnailImg: [],
        productVideos: [],
        multimediaImages: [],
        productVideosLinks: [],
        highlightsDocument: [],
        productTermsConditionsDoc: []
      });
    case 'WSO_RESPONSE':
      return Object.assign({}, state, { endpointRes: action.payload });
    case 'GET_GRANTTYPE_REQ_ATTR':
      return Object.assign({}, state, { grantTypeReqAttr: action.payload });
    case 'CLIENT_AUTH_ACCESS_TOKEN':
      return Object.assign({}, state, {
        tokenResponse: action.payload,
        tokenErrorResponse: {}
      });
    case 'ACCESS_TOKEN_ERROR':
      return Object.assign({}, state, {
        tokenResponse: {},
        tokenErrorResponse: action.payload
      });
    case 'ERR_FAILED':
      return Object.assign({}, state, {
        tokenResponse: {},
        tokenErrorResponse: {}
      });
    case 'USER_APPLICATION':
      return Object.assign({}, state, {
        applicationOfUsers: action.payload,
        mssApiAccessToken: ''
      });
    case 'GET_MSSAPIACCESS_TOKEN':
      return Object.assign({}, state, { mssApiAccessToken: action.payload });
    case 'BASE_URL':
      return Object.assign({}, state, { baseUrl: action.payload });
    case 'GET_BILLING_CYCLE_MASTER_DATA':
      return Object.assign({}, state, {
        billingCycleMasterData: action.payload
      });
    case 'SEND_EMAIL':
      return Object.assign({}, state, { sendMail: action.payload });
    case 'SEND_EMAIL_WITH_KEY_BODY':
      return Object.assign({}, state, { emailStatus: action.payload });
    case 'CLEAR_PRODUCT_QTY':
      return Object.assign({}, state, { totalProductQty: action.payload });
    case 'GET_PRODUCT_QTY':
      return Object.assign({}, state, {
        totalProductQty: action.payload.quantity
      });
    case 'CLEAR_PRODUCT_DISPLAY_NAMES':
    case 'GET_PRODUCT_DISPLAY_NAMES':
      return Object.assign({}, state, {
        productDisplayNames: action.payload
      });
    case 'SET_PRODUCT_QUANTITY':
      return Object.assign({}, state, { selectedProductQty: action.payload });
    case 'GET_HIGHLIGHTS_DOCUMENT':
      return Object.assign({}, state, { highlightsDocument: action.payload });
    case 'GET_CONSENT':
      return Object.assign({}, state, { userTermsConsent: action.payload });
    case 'POST_CONSENT':
      return Object.assign({}, state, { userTermsConsent: action.payload });
    default:
      return state;
  }
};

export default ProductDetailReducer;
